// extracted by mini-css-extract-plugin
export default {"radio":"MainSearchScope_radio__PnKCc","scope":"MainSearchScope_scope__eV0z-"};